import { render, staticRenderFns } from "./aboutArticle.vue?vue&type=template&id=9a7aa972&scoped=true"
import script from "./aboutArticle.vue?vue&type=script&lang=js"
export * from "./aboutArticle.vue?vue&type=script&lang=js"
import style0 from "./aboutArticle.vue?vue&type=style&index=0&id=9a7aa972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a7aa972",
  null
  
)

export default component.exports